var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1875 17.1875C17.1875 17.5672 16.8797 17.875 16.5 17.875C16.1203 17.875 15.8125 17.5672 15.8125 17.1875V15.8125C15.8125 14.6734 14.8891 13.75 13.75 13.75H8.25C7.11091 13.75 6.1875 14.6734 6.1875 15.8125V17.1875C6.1875 17.5672 5.8797 17.875 5.5 17.875C5.1203 17.875 4.8125 17.5672 4.8125 17.1875V15.8125C4.8125 13.914 6.35152 12.375 8.25 12.375H13.75C15.6485 12.375 17.1875 13.914 17.1875 15.8125V17.1875Z",
    fill: "#9738FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 11C9.10152 11 7.5625 9.46098 7.5625 7.5625C7.5625 5.66402 9.10152 4.125 11 4.125C12.8985 4.125 14.4375 5.66402 14.4375 7.5625C14.4375 9.46098 12.8985 11 11 11ZM11 9.625C12.1391 9.625 13.0625 8.70159 13.0625 7.5625C13.0625 6.42341 12.1391 5.5 11 5.5C9.86091 5.5 8.9375 6.42341 8.9375 7.5625C8.9375 8.70159 9.86091 9.625 11 9.625Z",
    fill: "#9738FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a32b8cc5b9fdc73866cac17a7db46b8a.svg";
export { ForwardRef as ReactComponent };